import React from "react";
import HeroContainer from "./HeroContainer";
import {
  Grid
} from "@material-ui/core";
// import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";
import { useSelector } from "react-redux";
import appActions from "components/app/actions";
import SimpleSnackbar from "components/common/SnackBar";



const HomeView = () => {
  // const { isMobile } = useGetViewPortDimensions();

  const { toast } = useSelector((state) => state.app);
  const { removeToastMessage } = appActions();
  const { message, type } = toast;
  return (
    <Grid>
      <HeroContainer />
      {message && (
        <SimpleSnackbar
          clearMessage={removeToastMessage}
          message={message}
          type={type}
        />
      )}
    </Grid>    
  );
};

export default HomeView;
